// extracted by mini-css-extract-plugin
export default {"logo":"Empty_logo__ZeP77","center":"Empty_center__k0Jax","emptyTitle":"Empty_emptyTitle__eqqnB","emptyDescription":"Empty_emptyDescription__MXqTB"};